/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const UpdateMonitoringIntegrationHeaders = zod.object({
  'x-csrf-token': zod.string(),
  'Idempotency-Key': zod.string(),
});

export type UpdateMonitoringIntegrationHeaders = zod.input<
  typeof UpdateMonitoringIntegrationHeaders
>;
export type UpdateMonitoringIntegrationHeadersOutput = zod.output<
  typeof UpdateMonitoringIntegrationHeaders
>;
